export default __webpack_public_path__ + "static/media/15-3D-(3-4).760df55f.jpg";